import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            background: 'var(--bg-body)',
            color: 'var(--text-main)',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: 64, marginBottom: 16 }}>⚠️</div>
          <h2 style={{ margin: '0 0 8px', fontSize: 24 }}>
            Something went wrong
          </h2>
          <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>
            We apologize for the inconvenience. Please refresh the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px',
              background:
                'linear-gradient(135deg, var(--primary-accent), var(--secondary-accent))',
              border: 'none',
              borderRadius: 8,
              color: '#fff',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            Refresh Page
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details
              style={{ marginTop: 24, textAlign: 'left', maxWidth: 600 }}
            >
              <summary style={{ cursor: 'pointer', marginBottom: 8 }}>
                Error Details
              </summary>
              <pre
                style={{
                  background: 'var(--bg-modal)',
                  padding: 12,
                  borderRadius: 8,
                  overflow: 'auto',
                  fontSize: 12,
                  color: '#ef4444',
                }}
              >
                {this.state.error.toString()}
                <br />
                <br />
                {this.state.errorInfo?.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
